import { type TopBannerProps } from './TopBannerProps'

export const TopBannerDefaults = {
  children: '',
  backgroundColor: '#BDF987',
  textColor: '#000',
  height: undefined,
  isSticky: false,
} satisfies TopBannerProps
